import './IconBadge.css';

export function IconBadge({ icon: Icon, tone = 'primary', size = 'md' }) {
  return (
    <span className={`icon-badge icon-badge--${tone} icon-badge--${size}`}>
      <Icon strokeWidth={2} />
    </span>
  );
}
